import type { MaasModelSource } from '@/delivery-type-plugin/capabilities/maas-init/maasTypes';

/** 已有 PVC 场景提交后端的占位 URL（标识模型已在共享卷中，无需远程下载） */
export const EXISTING_PVC_MODEL_SOURCE_URL = 'maas.stack.io/existing-pvc';

/** 构建已有 PVC 场景的 model.source 占位（使用 stackscope + 固定 URL，避免与 HuggingFace 混淆） */
export function buildExistingPvcModelSource(modelName: string): MaasModelSource {
  const name = String(modelName || '').trim() || 'model';
  return {
    stackscope: {
      model: name,
      url: EXISTING_PVC_MODEL_SOURCE_URL,
    },
  };
}

/** 判断 model.source 是否为已有 PVC 占位（含历史 huggingface 占位） */
export function isExistingPvcModelSource(source?: MaasModelSource, modelName?: string): boolean {
  if (!source) return false;

  const stackscopeUrl = String(source.stackscope?.url ?? '').trim();
  if (stackscopeUrl === EXISTING_PVC_MODEL_SOURCE_URL) return true;

  // 兼容旧版 huggingface 占位：仅含 huggingface.model 且无其他来源
  const hfModel = String(source.huggingface?.model ?? '').trim();
  if (!hfModel) return false;
  if (source.http || source.s3 || source.modelscope || source.stackscope) return false;
  if (modelName && hfModel === String(modelName).trim()) return true;
  return false;
}

/** 编辑回显时清除占位 source，避免误导用户 */
export function clearExistingPvcModelSourceForForm(source?: MaasModelSource, modelName?: string): MaasModelSource | undefined {
  if (!isExistingPvcModelSource(source, modelName)) return source;
  return {};
}
